<template v-if="relations.length > 0">
    <template v-for="relation in sidebarRelations">
        <div class="border-b border-border pb-4">
            <div class="py-4 flex flex-nowrap justify-between">
            <p class="text-2xl font-semibold">{{ upperCaseFirst(relation.title) }}</p>
                
                <RoundActionCreateButton
                    v-if="canAddRelations"
                    :modelClass="modelClass"
                    :url="relation.create_route"
                    :data="relation.create_route_params"
                    :dataOptions="relation.create_route_parameter_options"
                    :invertedColors="true"
                    :iconSize="'size-4'"
                />
            </div>
            <div>
                <div
                    :key="pageNumbers[relation.id]"
                    :class="['flex flex-col rounded-md gap-y-4']"
                >
                    <div
                        v-for="(item, index) in relation.pagination
                            .data"
                        v-if="relation.pagination?.data?.length"
                        :class="{
                            'pt-4': index > 0,
                            'pt-0': index == 0,
                        }"
                        class="py-6 px-2"
                    >
                        <DetailedListItem
                            @deleteModel="confirmDeleteModel"
                            :item="item"
                            :generateUrl="true"
                            :modelClass="relation.modelClass"
                            displayVariant="sidebar"
                            :panelModalClass="modelClass"
                            :showOptionsButton="true"
                            :isSideBarRelations="true"
                        />
                    </div>
                </div>
            </div>
        </div>
    </template>
    <ConfirmDeleteBaseModelModal
            v-if="$isAdmin"
            ref="confirmDeleteModal"
            :modelClass="modelToBeDeleted.model_class || null"
            :modelId="modelToBeDeleted.model_id || null"
            @delete="deleteModel"
            :emitInsteadOfDelete="true"
        />
</template>

<script>
import Pagination from '@/Components/DataTable/Pagination.vue'
import ResourceItem from '@/Components/Panels/RelationPanel/ResourceItem.vue'
import DetailedListItem from '@/Components/Panels/DetailedListItem.vue'
import { upperCaseFirst } from '@/Tools/utilities'
import { router } from '@inertiajs/vue3'
import ExpandingCreateButton from '@/Components/ModelComponents/ExpandingCreateButton.vue'
import ConfirmDeleteBaseModelModal from '@/Components/Modals/ConfirmDeleteBaseModelModal.vue'
import FlashMessage from '@/Components/Notifications/FlashNotifications/FlashMessage.vue'
import RoundActionCreateButton from '@/Components/ModelComponents/RoundActionCreateButton.vue'

export default {
    name: 'RelationPanel',

    components: {
        Pagination,
        ResourceItem,
        DetailedListItem,
        ExpandingCreateButton,
        ConfirmDeleteBaseModelModal,
        FlashMessage,
        RoundActionCreateButton
    },

    props: {
        sidebarRelations: {
            type: Array,
            required: true,
            validator: (relations) => {
                return relations.every((relation) => {
                    return (
                        Object.hasOwn(relation, 'id') &&
                        Object.hasOwn(relation, 'title') &&
                        Object.hasOwn(relation, 'modelClass') &&
                        Object.hasOwn(relation, 'pagination') &&
                        Object.hasOwn(relation, 'create_route') &&
                        Object.hasOwn(relation, 'create_route_params')
                    )
                })
            },
        },

        modelClass: {
            type: String,
            required: true,
        },

        canAddRelations: {
            type: Boolean,
            required: true,
        },

        availableEmotions: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            pageNumbers: {},
            modelToBeDeleted: {},
        }
    },

    mounted() {
        this.sidebarRelations.forEach((relation) => {
            this.pageNumbers[relation.modelClass] =
                relation.pagination?.current_page
        })
    },

    methods: {
        upperCaseFirst,

        changePage() {
            // Prevent URL updates during the request
            const originalPushState = window.history.pushState
            const originalReplaceState = window.history.replaceState
            window.history.pushState = () => {}
            window.history.replaceState = () => {}

            router.reload({
                preserveScroll: true,
                preserveState: true,
                onFinish: () => {
                    // Restore the original history methods
                    window.history.pushState = originalPushState
                    window.history.replaceState = originalReplaceState
                },
            })
        },

        confirmDeleteModel(model) {
            this.modelToBeDeleted = {
                model_id: model.id,
                model_class: model.modelClass,
            }
            this.$nextTick(() => {
                this.$refs.confirmDeleteModal.confirmDelete()
            })
        },

        deleteModel({ model_id, model_class }) {
            axios
                .delete(
                    this.$localizedRoute(`api.${model_class}.destroy`, model_id)
                )
                .then((response) => {
                    this.changePage()

                    this.$bus.emit(
                        'flash-message',
                        this.$lang.get(response.data.message)
                    )
                })
        },
    },
}
</script>
